enum SliderButtonLocations {
    Top = `top`,
    Bottom = `bottom`,
    Both = 'both'
}
    
export default SliderButtonLocations; 